import Parallax from 'parallax-js';
const swiperSlides = [...document.querySelectorAll('.swiper-wrapper .swiper-slide')];
let parallaxScene;
parallaxScene;

export const parallaxController = {
    init(slide) {
        parallaxScene = new Parallax(swiperSlides[slide].querySelector('.description__wrap'));
    },
    destroy() {
        if (parallaxScene) {
            parallaxScene.destroy();
            parallaxScene = undefined;
        }
    }
};
